import { render, staticRenderFns } from "./SvgShapeModal.vue?vue&type=template&id=027dec79&scoped=true"
import script from "./SvgShapeModal.vue?vue&type=script&lang=js"
export * from "./SvgShapeModal.vue?vue&type=script&lang=js"
import style0 from "./SvgShapeModal.vue?vue&type=style&index=0&id=027dec79&scoped=true&lang=css"
import style1 from "./SvgShapeModal.vue?vue&type=style&index=1&id=027dec79&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027dec79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027dec79')) {
      api.createRecord('027dec79', component.options)
    } else {
      api.reload('027dec79', component.options)
    }
    module.hot.accept("./SvgShapeModal.vue?vue&type=template&id=027dec79&scoped=true", function () {
      api.rerender('027dec79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/SvgShapeModal.vue"
export default component.exports